<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="container assign-course">
      <div class="row assign-nav">
        <div class="col-lg-1 col-sm-12"></div>
        <div class="col-lg-10 col-sm-12">
          <ul class="nav nav-pills mb-3 justify-content-center mt-5 tb">
            <li class="nav- click">
              <a class="nav-link" routerLink="/assignCourse/selectCourse">
                <span class="number">1</span> Select Courses</a
              >
            </li>
            <li class="nav-item click active">
              <a
                class="nav-link active"
                routerLink="/assignCourse/selectParticipant"
              >
                <span class="number">2</span> Select Participants</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link" routerLink="/assignCourse/chooseDate"
                ><span class="number">3</span>Choose Due Date</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link" routerLink="/assignCourse/confirmation"
                ><span class="number">4</span>Confirmation</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-sm-12">
          <p class="font-light font18 mt-4 p">
            Please select the participant(s) you will like to assign the
            selected course(s) to. You can select participants individually or
            in groups
          </p>
        </div>
        <div class="col-lg-9 col-sm-12 sm-mt">
          <div class="nav-card bg-white px-4 py-3">
            <ul class="nav nav-pills" id="pills-tab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="Individuals-tab"
                  data-toggle="pill"
                  href="#Individuals"
                  role="tab"
                  aria-controls="Individuals"
                  aria-selected="true"
                  >Individuals</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="Departments-tab"
                  data-toggle="pill"
                  href="#Departments"
                  role="tab"
                  aria-controls="Departments"
                  aria-selected="false"
                  >Departments</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="Division-tab"
                  data-toggle="pill"
                  href="#Division"
                  role="tab"
                  aria-controls="Divisions"
                  aria-selected="false"
                  >Divisions</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="Unit-tab"
                  data-toggle="pill"
                  href="#Unit"
                  role="tab"
                  aria-controls="Units"
                  aria-selected="false"
                  >Units</a
                >
              </li>
            </ul>
          </div>

          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane fade show active"
              id="Individuals"
              role="tabpanel"
              aria-labelledby="Individuals-tab"
            >
              <div class="bg-white px-4 pb-5 pt-1">
                <div
                  class="row align-items-center sm-reverse table-search-container"
                >
                  <!-- <div
                    class="text-green font12 font-bold col-lg-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
                  >
                    ADD FILTER
                  </div> -->
                  <div class="table-search col-lg-7 col-sm-12">
                    <input
                      type="text"
                      placeholder="Search"
                      #query
                      (keyup)="filter(query.value)"
                    />
                  </div>
                  <div
                    class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                  >
                    <mat-form-field appearance="outline">
                      <mat-label>SORT BY</mat-label>
                      <mat-select>
                        <mat-option
                          [value]="'fullName'"
                          (click)="sortBy('user', 'fullName')"
                        >
                          Name
                        </mat-option>

                        <mat-option
                          [value]="'username'"
                          (click)="sortBy('user', 'username')"
                        >
                          Email
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <!-- <span class="font-bold font14 text-grey mr-3">SORT BY</span> -->
                    <!-- <span class="dropdown click">
                      <span
                        class="font-bold text-green font12 dropdown-toggle"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        >Name <i class="fa fa-chevron-down"></i
                      ></span>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a
                          class="dropdown-item click line-under"
                          (click)="sortBy('fullName')"
                          >Name</a
                        >
                        <a
                          class="dropdown-item click"
                          (click)="sortBy('username')"
                          >Email</a
                        >
                      </div>
                    </span> -->
                  </div>
                </div>
                <div class="py-4">
                  <div class="col-12 click p-3">
                    <input
                      type="checkbox"
                      (change)="checkUncheckAll()"
                      [(ngModel)]="isIndividualCheck"
                      class=""
                    />
                    Select All
                  </div>
                  <div class="row">
                    <div
                      class="col-lg-6 col-sm-12 my-1"
                      *ngFor="
                        let staff of staffs
                          | paginate
                            : {
                                id: 'assign',
                                itemsPerPage: paginationInfo.size,
                                totalItems: paginationInfo.totalElements,
                                currentPage: paginationInfo.number
                              };
                        index as i
                      "
                    >
                      <input
                        (click)="selectDeselectIndividuals(staff?.id)"
                        type="checkbox"
                        id="checkbox{{ i }}"
                        class="checkbox"
                        [(ngModel)]="staff.isSelected"
                        [disabled]="selectedIndividuals.includes(staff)"
                      />
                      <label for="checkbox{{ i }}"
                        ><div
                          class="bg-grey px-4 py-3 d-flex justify-content-between align-items-center border-radius click"
                        >
                          <div class="d-flex align-items-center">
                            <div class="profile mr-3">
                              <img
                                src="{{
                                  staff?.user?.avatarUrl
                                    ? staff?.user?.avatarUrl
                                    : 'assets/images/profile.png'
                                }}"
                                alt=""
                                class="w-100 rounded-circle"
                              />
                            </div>
                            <div class="fixedCard">
                              <p class="mb-1 font-bold">
                                {{ staff?.user?.fullName }}
                              </p>
                              <p class="mb-0 text-grey font14">
                                {{ 
                                   staff.user?.username?.length > 30
                                    ? (staff.user.username | slice : 0 : 30) + '...'
                                    : staff.user.username 
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="check d-none">
                            <img src="assets/icons/check.png" alt="" />
                          </div></div
                      ></label>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <pagination-controls
                      id="assign"
                      (pageChange)="navigatePage($event)"
                    ></pagination-controls>
                  </div>
                </div>
              </div>
              <div class="my-5 d-flex justify-content-end">
                <button
                  (click)="individualContinue()"
                  [disabled]="selectedIndividuals.length === 0"
                  class="btn btn-secondary"
                >
                  Continue
                </button>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="Departments"
              role="tabpanel"
              aria-labelledby="Departments-tab"
            >
              <div class="bg-white pb-5 pt-1 px-4">
                <div
                  class="row align-items-center sm-reverse table-search-container"
                >
                  <div class="">
                    <!-- <span class="font-bold font14 text-grey mr-1"
                      >GROUP BY</span
                    >
                    <span class="dropdown click">
                      <span
                        class="font-bold text-green font12 dropdown-toggle"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        >Department <i class="fa fa-chevron-down"></i
                      ></span>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a class="dropdown-item click line-under">Department</a>
                        <a class="dropdown-item click">Division</a>
                        <a class="dropdown-item click">Unit</a>
                      </div>
                    </span> -->
                  </div>
                  <div class="table-search col-lg-6 col-sm-12">
                    <input
                      type="text"
                      placeholder="Search"
                      #query
                      (keyup)="filterDepartment(query.value)"
                    />
                  </div>
                  <div
                    class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                  >
                    <mat-form-field appearance="outline">
                      <mat-label>SORT BY</mat-label>
                      <mat-select>
                        <mat-option
                          [value]="'fullName'"
                          (click)="sortBy('departments', 'name')"
                        >
                          Name
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="py-4">
                  <div class="col-12 click p-3">
                    <input
                      type="checkbox"
                      (change)="checkUncheckAllDept()"
                      [(ngModel)]="isDepartmentCheck"
                      class=""
                    />
                    Select All
                  </div>
                  <div class="row">
                    <div
                      class="col-lg-6 col-sm-12 my-1"
                      *ngFor="let department of departments; index as j"
                    >
                      <input
                        (click)="selectDeselectDepartments(department?.id)"
                        type="checkbox"
                        id="department{{ j }}"
                        [(ngModel)]="department.isSelected"
                        class="checkbox"
                      />
                      <label for="department{{ j }}">
                        <div
                          class="bg-grey px-4 py-3 d-flex align-items-center border-radius click"
                        >
                          <div class="profile mr-3">
                            <img src="assets/icons/people.png" alt="" />
                          </div>
                          <div>
                            <p class="mb-1 font-bold">{{ department?.name }}</p>
                            <p class="mb-0 text-grey font14">
                              {{ department?.numberOfUsers }} Staff(s)
                            </p>
                          </div>
                          <div class="check d-none">
                            <img src="assets/icons/check.png" alt="" />
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="my-5 d-flex justify-content-end">
                <button
                  (click)="departmentContinue()"
                  [disabled]="selectedDepartments.length === 0"
                  class="btn btn-secondary"
                >
                  Continue
                </button>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="Division"
              role="tabpanel"
              aria-labelledby="Division-tab"
            >
              <div class="bg-white pb-5 pt-1 px-4">
                <div
                  class="row align-items-center sm-reverse table-search-container"
                >
                  <div class="">
                    <!-- <span class="font-bold font14 text-grey mr-1"
                      >GROUP BY</span
                    >
                    <span class="dropdown click">
                      <span
                        class="font-bold text-green font12 dropdown-toggle"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        >Division <i class="fa fa-chevron-down"></i
                      ></span>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a class="dropdown-item click line-under">Department</a>
                        <a class="dropdown-item click">Division</a>
                        <a class="dropdown-item click">Unit</a>
                      </div>
                    </span> -->
                  </div>
                  <div class="table-search col-lg-6 col-sm-12">
                    <input type="text" placeholder="Search" />
                  </div>
                  <div
                    class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                  >
                    <mat-form-field appearance="outline">
                      <mat-label>SORT BY</mat-label>
                      <mat-select>
                        <mat-option
                          [value]="'fullName'"
                          (click)="sortBy('divisions', 'name')"
                        >
                          Name
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="py-4">
                  <div class="col-12 click p-3">
                    <input
                      type="checkbox"
                      (change)="checkUncheckAllDiv()"
                      [(ngModel)]="isDivisionCheck"
                      class=""
                    />
                    Select All
                  </div>
                  <div class="row">
                    <div
                      class="col-lg-6 col-sm-12 my-1"
                      *ngFor="let division of divisions; index as j"
                    >
                      <input
                        (click)="selectDeselectDivisions(division?.id)"
                        type="checkbox"
                        id="division{{ j }}"
                        [(ngModel)]="division.isSelected"
                        class="checkbox"
                      />
                      <label for="division{{ j }}">
                        <div
                          class="bg-grey px-4 py-3 d-flex align-items-center border-radius click"
                        >
                          <div class="profile mr-3">
                            <img src="assets/icons/people.png" alt="" />
                          </div>
                          <div>
                            <p class="mb-1 font-bold">{{ division?.name }}</p>
                            <p class="mb-0 text-grey font14">
                              {{ division?.numberOfUsers }} Staff(s)
                            </p>
                          </div>
                          <div class="check d-none">
                            <img src="assets/icons/check.png" alt="" />
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="my-5 d-flex justify-content-end">
                <button 
                  (click)="divisionContinue()" 
                  [disabled]="selectedDivisions.length === 0"
                  class="btn btn-secondary"
                >
                  Continue
                </button>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="Unit"
              role="tabpanel"
              aria-labelledby="Unit-tab"
            >
              <div class="bg-white pb-5 pt-1 px-4">
                <div
                  class="row align-items-center sm-reverse table-search-container"
                >
                  <div class="r">
                    <!-- <span class="font-bold font14 text-grey mr-1"
                      >GROUP BY</span
                    >
                    <span class="dropdown click">
                      <span
                        class="font-bold text-green font12 dropdown-toggle"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        >Unit <i class="fa fa-chevron-down"></i
                      ></span>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a class="dropdown-item click line-under">Department</a>
                        <a class="dropdown-item click">Division</a>
                        <a class="dropdown-item click">Unit</a>
                      </div>
                    </span> -->
                  </div>
                  <div class="table-search col-lg-6 col-sm-12">
                    <input type="text" placeholder="Search" />
                  </div>
                  <div
                    class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                  >
                    <mat-form-field appearance="outline">
                      <mat-label>SORT BY</mat-label>
                      <mat-select>
                        <mat-option
                          [value]="'fullName'"
                          (click)="sortBy('units', 'name')"
                        >
                          Name
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="py-4">
                  <div class="col-12 click p-3">
                    <input
                      type="checkbox"
                      (change)="checkUncheckAllUnit()"
                      [(ngModel)]="isUnitCheck"
                      class=""
                    />
                    Select All
                  </div>
                  <div class="row">
                    <div
                      class="col-lg-4 col-sm-12 my-1"
                      *ngFor="let unit of units; index as j"
                    >
                      <input
                        (click)="selectDeselectUnits(unit?.id)"
                        type="checkbox"
                        id="unit{{ j }}"
                        [(ngModel)]="unit.isSelected"
                        class="checkbox"
                      />
                      <label for="unit{{ j }}">
                        <div
                          class="bg-grey px-4 py-3 d-flex align-items-center border-radius click"
                        >
                          <div class="profile mr-3">
                            <img src="assets/icons/people.png" alt="" />
                          </div>
                          <div>
                            <p class="mb-1 font-bold">{{ unit?.name }}</p>
                            <p class="mb-0 text-grey font14">
                              {{ unit?.numberOfUsers }} Staff(s)
                            </p>
                          </div>
                          <div class="check d-none">
                            <img src="assets/icons/check.png" alt="" />
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="my-5 d-flex justify-content-end">
                <button 
                  (click)="unitContinue()" 
                  [disabled]="selectedUnits.length === 0"
                  class="btn btn-secondary"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>
